import { defineStore } from 'pinia'
import { getHelpText } from '@/api/v2/static'

interface HelpData {
  text: string
  button: string
}

interface HelpState {
  help: HelpData | null
}

export const useHelpStore = defineStore('help', {
  state: (): HelpState => ({
    help: null
  }),

  actions: {
    async getHelpText(): Promise<HelpData> {
      const resp = await getHelpText()
      const data: HelpData = {
        text: resp.data.data.text,
        button: resp.data.data.button
      }
      this.help = data
      return data
    }
  }
})
